






























































































































	import { Component } from "../../../Infrastructure/CorBase/CoreBase";
    import RegistrationSelfBase from "./RegistrationSelfBase";
	@Component
    export default class RegistrationSelf extends RegistrationSelfBase {

		styleBackground() {
			return this.isTestEnvironment ? "background-color:darkcyan;" : "";
		}

        dynamicID() {
            var id = 'dynamicID-' + (Math.floor(Math.random() * Date.now()));
            return id;
        }

        goPageTrustlab() {
            let url: string = 'https://trustlab.cz/contact.html';

            window.open(url, '_blank')
        }



		// zobrazeni login stranky funguje jako odhlaseni
		created() {
			this.isLoginPage = true;
			super.setMainDescriptionOld(this.$t('login.login').toString(), this.$t('login.login').toString(), this.$t('login.login').toString(), this.$t('login.login').toString());
			super.setAlertModalId('alertModalIdLogin');
			
			this.versionNumberInLoginPage = "1.3.7x";
            this.getVersionNumberFromREST();
            this.createdBase();
		};

		isCorrectEmail(item: any) {
			this.isCorrectEmailBase(item);
		}

        isCorrectPassNew(value: any) {
            this.isCorrectPassNewBse(value);
        }

        isCorrectPassNew2(value: any) {
            this.isCorrectPassNewBase2(value);
        }


        getVersionNumber() {
            return "verze " + this.versionNumber;
        }

	

		enterPress(): void {
            this.enterPressBase();
		}

        mounted() {
            this.recongnizeLang();	
           
        }
	

	}
